import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  overflow: auto;

  @media (max-width: 768px) {
    padding-bottom: 5rem 0;
  }
`;

export const HeaderContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 1rem;
  background-color: #fff;
`

export const Title = styled.h1`
  text-align: center;
  color: #333;
`;

export const Paragraph = styled.p`
  color: #555;
  line-height: 1.6;
  margin: 1rem 0rem;
`;

export const Link = styled.a`
  color: #007bff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const ButtonContainer = styled.div`
    margin: 2rem 0;
`;

export const FooterButtonContainer = styled.div`
    margin: 2rem 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    
    @media (max-width: 768px) {
        margin-bottom: 3rem;
    }
`;